module.exports = "<img *ngIf=\"loading\" src=\"assets/images/loading.gif\" class=\"loading\">\r\n<ng-container *ngIf=\"available\">\r\n    <img [attr.src]=\"dataUrl$|async\" [attr.alt]=\"src| imageGetName\">\r\n</ng-container>\r\n<img *ngIf=\"!available\" src=\"assets/images/image_not_published.png\">"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/iipsrv-image/iipsrv-image.component.html
// module id = ./src/app/components/ui/iipsrv-image/iipsrv-image.component.html
// module chunks = main